import React from "react";
import ReactDOM from "react-dom";
// import Faqs from "../components/Faq/Faqs";
// import Messages from "../components/Messages/Messages";
// import "../components/Messages/Messages.css";
// import Flowchart from "../components/Flowchart/Flowchart";
import Articles from "../components/Article/Articles";
import Auditoriums from "../components/Auditoriums/Auditoriums";
// import ImgCarousel from "../components/Carousel/Carousel";
import ImgCarousel from "../components/Carousel/CarouselSlide";

import Collections from "../components/Collections/Collections";
import ContactUs from "../components/ContactUs/ContactUs";
import NewsLetter from "../components/ContactUs/NewsLetter/newsLetter";
import Events from "../components/Events/Events";
import ErrorBoundray  from "../components/ErrorBoundray/ErrorBoundray";
import Focus from "../components/Focus/Focus";
import FocusUnit from "../components/Focus/FocusUnit";
import Footer from "../components/Footer/Footer";

import HistoryEventsHP from "../components/HistoryEvents/HistoryEventsHP";
import HistoryEventsPages from "../components/HistoryEvents/HistoryEventsPages";

import Links from "../components/Links/Links";
import Lobby from "../components/Lobby/Lobby";
import MuseumEvents from "../components/Events/MuseumEvents";
import MuseumsEventsCal from "../components/Events/CalenderEvents/fullcalendar";
import MuseumsMap from "../components/Map/Map";
import News from "../components/News/News";
import Prices from "../components/Prices/Prices.js";
import SliderEvents from "../components/Events/SliderEvents";
import OldEventsSlider from "../components/Slider/OldEventsSlider";
import GallerySlider from "../components/Slider/GallerySlider";
import Slider from "../components/Slider/Slider";
import dataServices from "../common/dataServices";


class ModWebParts extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        items: [],
        webpartType:'',
        WpId:'',
        webpartLayout:'',
    };
    
    
    GetListItems(){

        let eventPageList = this.props.webPartProperties.ModText;
        let listName = eventPageList == 'isChild' ? 'דפים' : this.props.webPartProperties.listName;
        let viewName = eventPageList == 'isChild' ? 'אירועי עבר' : this.props.webPartProperties.listView;
        let siteUrl = eventPageList == 'isChild' ? this.props.webPartProperties.site + '/thismonthbefore' : this.props.webPartProperties.site;

        if(this.props.webPartProperties.ModBool == 'True') 
        {
            siteUrl = siteUrl.split('/sites')[0];
            listName = this.props.webPartProperties.ModText;
            viewName =  this.props.webPartProperties.readMoreLink;
        }

        if(listName != "ContactUs" && listName != "NewsLetter")
        {
            dataServices.getSPListItems(siteUrl,listName,viewName)
            .then((response)=>  response.data)   
                .then(lsItemsResponse=>{          
                    var itemsData = JSON.parse(lsItemsResponse);
            this.setState(
                {
                    items: itemsData,
                    webpartType: this.props.webPartProperties.type,
                    webpartTitle: this.props.webPartProperties.title,
                    WpId:this.props.webPartProperties.WpId,
                    webpartLayout:this.props.webPartProperties.layout
                } 
            )
            })
            }
        else
            {
                this.setState(
                    {
                        webpartType: this.props.webPartProperties.type,
                        webpartTitle: this.props.webPartProperties.title,
                            WpId:this.props.webPartProperties.WpId,
                            webpartLayout:this.props.webPartProperties.layout
                    } 
                )
        }
    }


    componentDidMount() {  
        //  console.log("componentDidMount");
        //console.log(this.props.webPartProperties);
          // if(this.props.webPartProperties.searchQueryInput != '')
          // {
            
          //     this.getFromSearchApi();
          // }
          // else{
            //   if(this.props.webPartProperties.type != "ContactUs" && this.props.webPartProperties.type != "Icons" )
            //   {
                  this.GetListItems();
            //   }
            //   else{
               ///  this.prepareState([]);
                 //console.log("contactUs")
              //}
          //
      }  
    render() {
        let selectedWP="";
        let wpClass='';
        let wrap='';
        let publishFilteredPages = this.state.items.filter(page => {
            return page._ModerationStatus == "0";
        });

        if(this.state.webpartType=='Article'){
            selectedWP = <Articles items={publishFilteredPages}/>
        }
        else if(this.state.webpartType=='Auditoriums'){
            selectedWP = publishFilteredPages.map((item,index) => (
                <Auditoriums data={item} key={'Auditoriums'+index}/>
            ))
        }
        else if(this.state.webpartType=='Carousel'){
            selectedWP =  <ImgCarousel items={publishFilteredPages} 
                        wpId={this.state.WpId} moreLink={this.props.webPartProperties.readMoreLink} 
                        moreTitle={this.props.webPartProperties.readMoreTitle}  
                        subText={this.props.webPartProperties.ModText}
                        carouselRendition ={this.props.webPartProperties.ModNumber}/>
        }
        else if(this.state.webpartType=='Collections'){
            selectedWP = publishFilteredPages.map((item,index) => (
                <Collections data={item} key={'Collections'+index}/>
            ))
        }
        else if(this.state.webpartType=='ContactUs'){
            let sitesNotUnit = ((this.props.webPartProperties.site).indexOf("sites")>=0);
            if(this.state.webpartLayout == 'first'){                
                selectedWP =  <ContactUs items={publishFilteredPages} siteUrl={this.props.webPartProperties.site}  
                mailTo={this.props.webPartProperties.ModText} lang={this.props.webPartProperties.readMoreTitle} unitOrSites={sitesNotUnit} museumsDropDown={this.props.webPartProperties.ModNumber}/>
            }
            else if (this.state.webpartLayout == 'second') {
                selectedWP =  <NewsLetter items={publishFilteredPages} siteUrl={this.props.webPartProperties.site}  
                mailTo={this.props.webPartProperties.ModText} lang={this.props.webPartProperties.readMoreTitle} unitOrSites={sitesNotUnit} museumsDropDown='1'/>
            }

                        
        }
        else if(this.state.webpartType=='Events')
        {
            if(this.state.webpartLayout == 'first'){
                selectedWP = <SliderEvents data={publishFilteredPages} allEventsLink={this.props.webPartProperties.ModText}/>
            }
            else if (this.state.webpartLayout == 'second'){
                selectedWP = publishFilteredPages.map((item,index) => <MuseumEvents data={item} key={'Events'+index}/>)  
            }
            else if(this.state.webpartLayout == 'third'){
                selectedWP =  <MuseumsEventsCal data={publishFilteredPages}/>
            }
        }
        else if(this.state.webpartType=='HistoryEvents')
        {
            if(this.state.webpartLayout == 'first'){
                selectedWP = <HistoryEventsHP data={publishFilteredPages} allEventsLink={this.props.webPartProperties.readMoreTitle}/>
            }
            else if (this.state.webpartLayout == 'second'){
                selectedWP = <HistoryEventsPages data={publishFilteredPages} allEventsLink={this.props.webPartProperties.readMoreTitle}/>
            }
        }

        else if(this.state.webpartType=='Focus'){
                if(this.state.webpartLayout == 'second'){
                selectedWP = publishFilteredPages.map((item,index) => (
                    <FocusUnit data={item} key={"FocusUnit_"+index}/>
                ))
            }
            else
            {
                selectedWP = publishFilteredPages.map((item,index) => (
                    <Focus data={item} key={"Focus_"+index}/>
                )) 
            }
        }
        else if(this.state.webpartType=='Footer'){
            let sitesNotUnit = ((this.props.webPartProperties.site).indexOf("sites")>=0);
            
            selectedWP = publishFilteredPages.map((item,index) => (
                <Footer data={item} key={"Footer_"+index} lang={this.props.webPartProperties.readMoreTitle} sitesNotUnit={sitesNotUnit} />
            )) 
        }
        else if(this.state.webpartType=='Links'){

            selectedWP = <Links items={publishFilteredPages} layout={this.state.webpartLayout}  
                            moreLink={this.props.webPartProperties.readMoreLink} 
                            linkTitle={this.props.webPartProperties.readMoreTitle}
                            allMuseums={this.props.webPartProperties.ModText}/>
        }
        else if(this.state.webpartType=='Lobby'){
            selectedWP = publishFilteredPages.map((item,index) => (
                <Lobby data={item} key={'Lobby'+index}/>
            ))
        }
        else  if(this.state.webpartType=='Map')
        {
            selectedWP = <MuseumsMap items={publishFilteredPages} moreTitle={this.props.webPartProperties.readMoreTitle} subText={this.props.webPartProperties.ModText}/>
        }
        else if(this.state.webpartType=='News'){            
            {(publishFilteredPages) && 
                (selectedWP =  <News data={publishFilteredPages[this.props.webPartProperties.ModText]} />)
            }
        }
        else if(this.state.webpartType=='Prices'){
            selectedWP =  <Prices data={publishFilteredPages} />
        }
        else if(this.state.webpartType=='Slider'){
            if(this.state.webpartLayout == 'third'){
                selectedWP = 
                    <OldEventsSlider items={publishFilteredPages} />
            }
            else if(this.state.webpartLayout == 'second'){
                selectedWP = 
                    <GallerySlider items={publishFilteredPages} />
            }
            else
            {
            selectedWP = 
                <Slider items={publishFilteredPages} />
            }
        }
      
        return (
            <div className={'modWP'+this.state.webpartType+ wpClass+" "+this.state.webpartLayout}>
                    {this.state.webpartTitle?<h2>{this.state.webpartTitle}</h2>:null}
                    {/* <div class='row'> */}
                    <ErrorBoundray>

                        {selectedWP}
                    </ErrorBoundray>
                    {/* </div>  */}
            </div>
        );
    }
}
export default ModWebParts;




